import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpStatusCode } from '../utility/HttpStatusCode';

@Component({
  selector: 'lg-error',
  templateUrl: 'error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errorCode: string;
  httpStatusCode: any;

  constructor(private route: ActivatedRoute) {
    this.httpStatusCode = HttpStatusCode;
  }

  ngOnInit(): void {
    this.errorCode = this.route.snapshot.data.code;
  }
}
